export default {
  props: {
    content: {
      required: true,
      type: Object
    }
  }
};
